import { SvgIcon } from '@material-ui/core'

export default (props) => (
  <SvgIcon {...props} viewBox='0 0 1000 1000'>
    <path d='m212,842l630,-630q10,-11 13,-21t-2,-16l-28,-28q-5,-5 -15,-2t-21,13l-631,630q-10,11 -13,22t2,15l28,28q5,5 16,2t21,-13zm654,-708q-7,-8 -19,-8l-195,-1q-11,0 -18,8t-8,19l0,22q0,12 8,20t19,8l145,0l1,145q0,12 8,20t19,7l22,0q11,1 19,-7t8,-19l-1,-195q0,-11 -8,-19zm-732,732q8,8 19,8l195,1q11,0 19,-8t7,-19l1,-22q-1,-12 -9,-19t-19,-8l-145,-1l0,-145q-1,-11 -9,-19t-19,-8l-22,0q-11,-1 -19,7t-8,20l1,194q0,11 8,19z' />
  </SvgIcon>
)
